export default __webpack_public_path__ + "static/media/michelle.13ac975e.jpg";